import { EUserType } from '@src/types';

const HOST_FILTERS = [
  { value: 'ALL', label: 'All Questions' },
  { value: 'ANSWERED', label: 'Answered questions' },
  { value: 'DISMISSED', label: 'Dismissed questions' },
  { value: 'ASSIGNED_TO_OTHERS', label: 'Assigned to others' },
  { value: 'ANSWERED_BY_ME', label: 'Answered by me' },
  { value: 'ANSWERED_IN_PUBLIC', label: 'Answered in public' },
  { value: 'UNASSIGNED', label: 'Not assigned questions' },
];

export const QUESTION_FILTERS = {
  [EUserType.HOST]: HOST_FILTERS,
  [EUserType.CO_HOST]: HOST_FILTERS,
  [EUserType.SPEAKER]: [
    { value: 'ASSIGNED_TO_ME', label: 'Assigned to me' },
    { value: 'ANSWERED_IN_PUBLIC', label: 'Answered in public' },
    { value: 'ANSWERED_BY_ME', label: 'Answered by me' },
  ],
  [EUserType.ATTENDEE]: [
    { value: 'MY_QUESTIONS', label: 'My Questions' },
    { value: 'ANSWERED_IN_PUBLIC', label: 'Public Q&A' },
  ],
};

export const SORT_OPTIONS = [
  { value: 'NEWEST', label: 'Newest first' },
  { value: 'OLDEST', label: 'Oldest first' },
];
